// startup
// Load entry module and return exports
// This entry module is referenced by other modules so it can't be inlined
__webpack_require__("./node_modules/whatwg-fetch/fetch.js");
var __webpack_exports__ = __webpack_require__("./ts/index.tsx");
